// src/app/features/auth/kycApi.js
import http from "../../api/http.js";

function extractDetail(err) {
  const data = err?.response?.data;
  if (!data) return err?.message || "Request failed";
  if (typeof data?.detail === "string") return data.detail;
  if (Array.isArray(data?.detail)) {
    return data.detail
      .map((d) => d?.msg || d?.message)
      .filter(Boolean)
      .join("; ");
  }
  return JSON.stringify(data);
}

export async function submitKyc(formData) {
  try {
    // must be multipart/form-data
    const res = await http.post("/kyc/submit", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  } catch (err) {
    err.message = extractDetail(err);
    throw err;
  }
}
